const docStyle = getComputedStyle(document.documentElement);
const solveNormalization = (container) => {
    if (!container) return;

    const style = getComputedStyle(container);

    // These three names must match the --logo-* declarations in
    // 01-base/_scaling.scss. A rename yields NaN multipliers and every logo
    // collapses to 0x0 with no error. See ARCHITECTURE.md.
    const SCALE_ADJ = parseFloat(style.getPropertyValue("--logo-scale-adj")) || parseFloat(docStyle.getPropertyValue("--logo-scale-adj"));
    const MAX_W_FACTOR =
        parseFloat(style.getPropertyValue("--logo-max-w-factor")) || parseFloat(docStyle.getPropertyValue("--logo-max-w-factor"));
    const MAX_H_FACTOR =
        parseFloat(style.getPropertyValue("--logo-max-h-factor")) || parseFloat(docStyle.getPropertyValue("--logo-max-h-factor"));

    const logos = Array.from(container.querySelectorAll("img"));

    const process = () => {
        logos.forEach((img) => {
            if (!img.naturalWidth) return;

            const ratio = img.naturalWidth / img.naturalHeight;
            const nudge = parseFloat(img.dataset.weight) || 1.0;

            // 1. CALCULATE RELATIVE MULTIPLIER
            // Locked Logarithmic relationship relative to the base anchor
            let hMult = (1 / Math.log10(ratio * SCALE_ADJ + 1)) * nudge;
            let wMult = hMult * ratio;

            // 2. ENFORCE FENCES
            if (wMult > MAX_W_FACTOR) {
                wMult = MAX_W_FACTOR;
                hMult = wMult / ratio;
            }
            if (hMult > MAX_H_FACTOR) {
                hMult = MAX_H_FACTOR;
                wMult = hMult * ratio;
            }

            // 3. INJECT AS CSS VARIABLES
            // Allows browser-native scaling with px, vw, rem, or pxv
            img.style.setProperty("--logo-h-mult", hMult.toFixed(4));
            img.style.setProperty("--logo-w-mult", wMult.toFixed(4));
        });
    };

    // LOAD MANAGEMENT
    let loaded = 0;
    logos.forEach((img) => {
        if (img.complete && img.naturalWidth > 0) loaded++;
        else
            img.onload = img.onerror = () => {
                if (++loaded === logos.length) process();
            };
    });
    if (loaded === logos.length) process();
};

document.querySelectorAll(".logo-scale").forEach(solveNormalization);
